import { useCallback } from 'react';
import { useLazyDownloadReleaseNoteAsTextQuery } from '@/store/api';
/**
 * Platform-services lazy-query hook for downloading a release note as markdown text.
 *
 * @see src/store/api/cc/releaseNotesApi.ts
 */
export const useLazyDownloadReleaseNoteAsText = () => {
    const [trigger, { data, isLoading, isFetching, isError, error, }] = useLazyDownloadReleaseNoteAsTextQuery();
    const triggerDownloadAsText = useCallback((fileName) => trigger({ fileName }).unwrap(), [trigger]);
    return {
        triggerDownloadAsText,
        data,
        isLoading: isLoading || isFetching,
        isError,
        error,
    };
};
